















































import {Component, Vue, Watch} from "vue-property-decorator";
import ArrowRightSvg from "@/assets/svg/arrow-right.svg";
import BaseOverview, {Loadable} from "@/resources/components/BaseOverview.vue";
import ProductionOrder from "@/app/models/ProductionOrder";
import Cluster from "@/app/models/Cluster";
import {AxiosError} from "axios";
import PaginatedResponse from "@/app/models/Concerns/PaginatedResponse";
import Debounce from "@/app/support/Debounce";
import CheckMark from "@/assets/svg/check.svg";

@Component({
    components: {BaseOverview, ArrowRightSvg, CheckMark},
})
export default class Dashboard extends Vue {
    cluster: Cluster | null = null;
    search: string = '';

    $refs!: { overview: BaseOverview }

    @Watch('search')
    @Debounce(250)
    onSearchUpdated() {
        this.$refs.overview.reset();
    }

    async loadItems(loadable: Loadable) {
        // @ts-ignore
        const productionOrders: PaginatedResponse<ProductionOrder> = await Cluster.productionOrders(loadable.page, {search: this.search})
            .catch((error: AxiosError) => {
                this.flash(this.$t('Whoops #' + error.response!.status));
                loadable.loadItems([]);
            });

        loadable.loadItems(productionOrders.data);
    }

    async beforeMount() {
        this.cluster = await Cluster.current();
    }
}
